/* eslint-disable */
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { VscArrowRight } from "react-icons/vsc";
import { useSelector } from "react-redux";
import ApiNew from "./Api";
import PARSE from "html-react-parser";

const api = new ApiNew();

export default function SSoft_Service_Why() {
  const activeLanguage = useSelector((state) => state.content.activeLanguage);
  const [title, setTitle] = useState(null);
  const [qcSummary, setQcSummary] = useState(null);
  const [qcValue, setQcValue] = useState([]);
  const [qcLink, setQcLink] = useState(null);
  const [listLine, setListLine] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [sections, setSections] = useState([]);
  const [menus, setMenus] = useState([]);

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const [sectionRes, menuRes] = await Promise.all([
          api.getSectionDetail({ language: activeLanguage }),
          api.getMenuDetail({ language: activeLanguage }),
        ]);

        // Assuming responses follow typical structure: { data: { results: [...] } }
        if (sectionRes?.data?.results) {
          setSections(sectionRes.data.results);
        } else {
          setSections([]);
        }

        // Assuming menu response: { data: { items: [...] } }
        if (menuRes?.data?.items) {
          setMenus(menuRes.data.items);
        } else {
          setMenus([]);
        }
      } catch (err) {
        console.error("Error fetching section or menu data:", err);
        // Optionally set error state or show notification
        setSections([]);
        setMenus([]);
      }
    };

    fetchDetails();
  }, [activeLanguage]);

  useEffect(() => {
    let switchCaseCompleted = 0;

    if (sections.length > 0) {
      const sec = sections[0]?.widgets;
      if (sec && sec.length !== 0) {
        sec.forEach((section, i) => {
          switch (i) {
            case 0: {
              setTitle(section?.widget_contents[0]);
              break;
            }
            case 1: {
              setQcSummary(section?.widget_contents[0]);
              break;
            }
            case 2: {
              setQcValue(section?.widget_contents);
              break;
            }
            case 3: {
              setQcLink(section?.widget_contents[0]);
              break;
            }
            default:
              break;
          }

          switchCaseCompleted++;
        });

        if (switchCaseCompleted === 2) {
          setLoaded(true);
        }
      }
    }
  }, [sections]);
  return (
    <section className="py-16 bg-gradient-to-b from-white via-gray-50/50 to-[#255262]/50">
      <div className="section-container section-margin-x">
        <div className="flex flex-col lg:flex-row gap-12">
          <div className="lg:w-2/3 space-y-8">
            <h2 className="header-style-non-hero">
              {title?.article_language?.title}
            </h2>

            <div className="space-y-8 ">
              <p className=" max-w-2xl  prose-why content-why">
                {PARSE(title?.article_language?.content || "")}
              </p>
            </div>

            <p className=" header-style-non-hero">
              {" "}
              {title?.article_language?.summary}
            </p>

            <div className="mt-6 grid gap-3">
              {menus?.map((link, i) => (
                <Link
                  key={i}
                  to={link.url}
                  className=" "
                  aria-label={link.title}
                >
                  <div className="flex items-center  hover:underline">
                    <span className="content-subheader-style-non-hero tdext-[#255262] ">
                      {link.title}
                    </span>

                    <VscArrowRight className="ml-3 shrink-0 text-[#255262]" />
                  </div>
                </Link>
              ))}
            </div>
          </div>

          {/* Quick Contact Panel */}
          <div className="lg:w-1/3 relative">
            {/* Decorative Background Elements */}
            <div className="absolute inset-0 bg-gradient-to-br from-[#255262]/5 via-transparent to-[#255262]/5  blur-xl -z-10"></div>

            <div className="relative bg-white/80 backdrop-blur-xl p-6 md:p-8  shadow-xl border border-white/20 overflow-hidden">
              {/* Header with Icon */}
              <div className="flex items-center gap-3 mb-4">
                <div className="relative">
                  <div className="w-10 h-10 bg-gradient-to-br from-[#255262] to-[#255262]/80  flex items-center justify-center shadow-lg">
                    <svg
                      className="w-5 h-5 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                      />
                    </svg>
                  </div>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-[#255262] mb-1">
                    {qcSummary?.article_language?.title}
                  </h3>
                  <p className="text-sm text-[#255262]/80 font-medium">
                    {qcSummary?.article_language?.summary}
                  </p>
                </div>
              </div>

              {/* Description */}
              <p className=" mb-6 leading-relaxed text-sm">
                {PARSE(qcSummary?.article_language?.content || "")}
              </p>

              <div className="grid grid-cols-2 gap-4 mb-6">
                {qcValue?.map((item, index) => (
                  <div
                    key={index}
                    className="text-center p-2 bg-gradient-to-br from-[#255262]/5 to-[#255262]/5"
                  >
                    <div className="text-2xl font-bold text-[#255262]">
                      {item.article_language?.title}
                    </div>
                    <div className="qc-contnet-ck">
                      {item.article_language?.summary}
                    </div>
                  </div>
                ))}
              </div>

              {/* CTA Button - Fixed overflow */}
              <Link to={qcLink?.article_language?.path}>
                <button className="flex items-center justify-center h-[48px]   fhd:text-[18px] text-[16px] w-full font-inter bg-[#255262] rounded-[8px] text-white  font-semibold leading-[20px] shadow-lg hover:shadow-xl">
                  <span className="flex items-center justify-center gap-2 ">
                    {qcLink?.article_language?.title}
                    <VscArrowRight />
                  </span>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
